module.exports = __webpack_public_path__ + "static/media/soccer-large.d3732c18.svg";